const className = 'prose dark:prose-invert prose-red font-condensed prose-lg'

export { className as prose }
